export default __webpack_public_path__ + "static/media/li-wedding-288-4_tn.fed8a236.jpg";